import React from "react";
import {
  Box,
  Paper,
  Skeleton,
  Grid,
} from "@mui/material";

const ScheduleCardSkeleton = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid #E2E8F0",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 1,
          mb: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton variant="rounded" width={24} height={24} />
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="rounded" width={60} height={24} />
        </Box>

        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </Box>

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Box>
              <Skeleton variant="text" width={80} height={16} />
              <Skeleton variant="text" width={120} height={20} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Box>
              <Skeleton variant="text" width={80} height={16} />
              <Skeleton variant="text" width={100} height={20} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Box>
              <Skeleton variant="text" width={80} height={16} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={16} height={16} />
            <Box>
              <Skeleton variant="text" width={80} height={16} />
              <Skeleton variant="text" width={150} height={20} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              pt: 1,
              borderTop: "1px solid #F1F5F9",
            }}
          >
            <Skeleton variant="text" width={120} height={16} />
            <Skeleton variant="rounded" width={100} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ScheduleCardSkeleton;